import Button from "@components/Button/Button";
import { ButtonUpdated } from "@components/ButtonUpdated/ButtonUpdated";
import Modal from "@components/Modal/Modal";
import YesNoToggle from "@components/YesNoToggle/YesNoToggle";
import CloseIcon from "@images/closeModal.svg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IFile } from "types/file";
import styles from "./FileSettingsModal.module.scss";

export interface IFileSettingsModalProps {
  open: boolean;
  onClose: () => void;
  file: IFile;
  handleSubmitFileSettings: (file: IFile) => void;
}

const FileSettingsModal = ({
  open,
  onClose,
  file,
  handleSubmitFileSettings,
}: IFileSettingsModalProps) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(file.isEditable);

  const handleCheckboxChange = (value: boolean) => {
    setChecked(() => {
      return value;
    });
  };

  const submit = (updatedFile: IFile) => {
    updatedFile.isEditable = checked;
    handleSubmitFileSettings(updatedFile);
  };

  return (
    <Modal modalType="primary" isOpen={open} onRequestClose={onClose}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.title}>{t("collections.fileSettingsModal.title")}</span>
          <ButtonUpdated
            title=""
            wrapperClassNames={styles.closeButtonWrapper}
            buttonShape="circle"
            onClick={onClose}
            buttonIcon={<img alt="" className={styles.removeIcon} src={CloseIcon} />}
            hasBorder={false}
          />
        </div>
        <hr className={styles.divider} />
        <span className={styles.fileName}>
          Would you like you change the settings for below file.
        </span>
        <hr />
        <div className={styles.fileRowHeader}>
          <div className={styles.divFileName}>
            <span className={styles.headerLabel}>File Name</span>
          </div>
          <div className={styles.divToggle}>
            <span className={styles.headerLabel}>Edit Permission</span>
          </div>
        </div>
        <div className={styles.fileRow}>
          <div className={styles.divFileName}>
            <span className={styles.fileName}>
              <b>
                {1}
                {". "}
              </b>
              {file.name}
            </span>
          </div>
          <div className={styles.divToggle}>
            <YesNoToggle
              value={checked ?? false}
              onChange={(value) => handleCheckboxChange(value)}
            />
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <span className={styles.cancelButton} onClick={onClose} aria-label="cancel">
            {t("collections.fileSettingsModal.cancel")}
          </span>
          <Button
            type="submit"
            buttonType="primary"
            title={t("collections.fileSettingsModal.submit")}
            aria-label="button-submit"
            onClick={() => submit(file)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default FileSettingsModal;
